import AppsScene from '../scenes/AppsScene';

const routes = [
  {
    path: '/apps/*',
    menuName: 'apps_plural',
    component: AppsScene,
    hasRight: 'APPS.MANAGE.ALL',
  },
];

export default routes;
